import KitBuilderBase from "@/components/KitBuilderBase";
import { CCTV_KIT } from "@/kitConfigs";

export default function CctvKitBuilder() {
  return <KitBuilderBase config={CCTV_KIT} />;
}
